import type { ConnectorCatalogItem } from "@/types/connectors.ts";
import type { CustomMcpAuthChoice, McpAuthMode } from "@/types/mcp.ts";

/**
 * The pure half of the custom MCP server flow, shared by web's dialog and
 * native's sheet so the two never disagree on what a probe result means or
 * which tile is the user's to rename and remove.
 */

/** The numeric server id behind a custom tile's `mcp:<id>` catalog id, or null for any other tile. */
export const customMcpServerIdOf = (item: ConnectorCatalogItem): number | null => {
  if (!item.custom) return null;
  const match = /^mcp:(\d+)$/.exec(item.id);
  return match ? Number(match[1]) : null;
};

/** The sign-in choice the probe settled, or null when the user has to pick. */
export const customMcpAuthModeFor = (choice: CustomMcpAuthChoice): McpAuthMode | null =>
  choice === "oauth" || choice === "api_key" || choice === "none" ? choice : null;

/** The three sign-in methods a user can pick for their server, in display order. */
export const CUSTOM_MCP_AUTH_OPTIONS: readonly { value: McpAuthMode; label: string }[] = [
  { value: "oauth", label: "Sign in with the service" },
  { value: "api_key", label: "API key" },
  { value: "none", label: "No sign-in" },
];
